import React, { useState, useEffect, useCallback } from 'react';
import FirstStep from './FirstStep/FirstStep';
import LastStep from './LastStep/LastStep';
import StepWithIcon from './StepWithIcon/StepWithIcon';
import styles from './Steps.module.scss';

/*eslint max-lines-per-function: ["error", 200]*/
const Steps = ({ steps, params = [] }) => {
  const middleSteps = steps.slice(1, -1);
  const [stepPositions, setStepPositions] = useState([]);
  const [stepsToRender, setStepsToRender] = useState(0);
  const [renderedSteps, setRenderedSteps] = useState(0);
  const [delay, setDelay] = useState(false);

  const renderNextStep = useCallback(() => {
    if(!delay && stepsToRender > renderedSteps) {
      setRenderedSteps(prev => prev + 1);
    }
  }, [delay, stepsToRender, renderedSteps]);

  useEffect(() => {
    window.addEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    renderNextStep();
  }, [stepsToRender]);

  useEffect(() => {
    setDelay(true);
    setTimeout(() => setDelay(false), 150);
  }, [renderedSteps]);


  useEffect(() => {
    renderNextStep();
    if (stepsToRender === renderedSteps &&
      stepsToRender < steps.length &&
      !delay
    ) {
      onScroll();
      window.addEventListener('scroll', onScroll);
    }
  }, [delay]);

  const getPosition = useCallback((number) => (node) => {
    const { offsetTop, offsetHeight } = node;
    const bottom = offsetTop + offsetHeight;

    setStepPositions(prev => {
      prev[number] = bottom;
      return prev;
    });
  }, []);

  const renderStep = useCallback((step, i) => {
    const number = i + 2;
    const stepProps = { step, number };
    const stepParams = {};

    Object.keys(params).forEach((param) => {
      stepParams[param] = params[param].includes(number);
    });

    return (
      <StepWithIcon
        key={step.text || step}
        step={stepProps}
        params={stepParams}
        rendered={renderedSteps >= i + 1}
        number={number}
        getPosition={getPosition(number)}
      />
    );
  }, [renderedSteps]);

  const onScroll = useCallback(() => {
    const scrollPosition = window.pageYOffset + window.innerHeight - 100;

    if (scrollPosition > stepPositions[stepPositions.length - 1]) {
      window.removeEventListener('scroll', onScroll);
      setStepsToRender(stepPositions.length);
    } else if(stepsToRender) {
      const nextStepToRender = stepPositions
        .findIndex(stepPosition => {
          return stepPosition && scrollPosition < stepPosition;
        }) - 2;

      if(stepsToRender !== nextStepToRender) {
        window.removeEventListener('scroll', onScroll);
      }
      setStepsToRender(prev => {
        return Math.max(prev, nextStepToRender);
      });
    } else if (scrollPosition > stepPositions[2]) {
      window.removeEventListener('scroll', onScroll);
      setStepsToRender(1);
    }
  }, [stepsToRender]);

  return (
    <div className={styles.Steps}>
      <FirstStep {...steps[0]} />
      <div className={styles.middleSteps}>
        {middleSteps && middleSteps.map(renderStep)}
      </div>
      <LastStep text={steps[steps.length - 1]} lastNumber={steps.length} />
    </div>
  );
};

export default Steps;
